import notFound from './view/NotFoundView';

export const NotFound = notFound;
